import { useQuery } from '@apollo/client';
import { TransactionEntryCategoryGroupsDocument } from '../../graphql/generated';

export const useTransactionEntryCategoryGroups = () => {
    const {
        data: transactionEntryCategoryGroupsQuery,
        loading: transactionEntryCategoryGroupsLoading,
    } = useQuery(TransactionEntryCategoryGroupsDocument);

    return {
        transactionEntryCategoryGroups:
            transactionEntryCategoryGroupsQuery?.transactionEntryCategoryGroups,
        transactionEntryCategoryGroupsLoading,
    };
};
